import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'
import BookingInfoModal from 'components/AvailabilityDataTable/components/BookingInfoModal'

const MyBookingsWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [bookings, setBookings] = useState([]);
  const [title, setTitle] = useState('');
  const [showBookingInfoModal, setShowBookingInfoModal] = useState(false)
  const [modalBookingId, setModalBookingId] = useState(null)

  useEffect(() => {
    mounted.current = true;
    fetch('supplierdashboard/My_Bookings')
    .then((response) => response.json())
    .then(({data}) => {
      if (mounted.current) {
        if (data.bookings.bookingEntries) {
          setBookings(data.bookings.bookingEntries);
        }
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  useEffect(() => {
    if (modalBookingId) {
      setShowBookingInfoModal(true)
    }
  }, [modalBookingId])

  const getStartDate = (booking) => {
    const value = new Date(booking.dateStart * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const getEndDate = (booking) => {
    const value = new Date(booking.dateEnd * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const widget_id = `ID_${widget.widgetId}`;
  
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <table className="w-full table-fixed text-xs">
        <thead>
          <tr>
            <td className="border-b p-2">Start</td>
            <td className="border-b p-2">End</td>
            <td className="border-b p-2">Message</td>
            <td className="border-b p-2 w-1/12"></td>
          </tr>
        </thead>

        <tbody>
          {bookings.map((booking, i) => (
            <tr key={i} title={booking.message} className="hover:bg-gray-200 dataRow cursor-pointer" onClick={() => setModalBookingId(booking.uid)} >
              <td className="border-b p2">{getStartDate(booking)}</td>
              <td className="border-b p2">{getEndDate(booking)}</td>
              <td className="border-b p-2 truncate">
                  {booking.message}
              </td>
              <td className="border-b p-2 w-1/12">
                {booking.accepted == 1 && <img src="/css/images/accept.png" />}
                {booking.rejected == 1 && <img src="/css/images/delete.png" />}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BookingInfoModal show={showBookingInfoModal} bookingId={modalBookingId} onClose={() => setShowBookingInfoModal(false)} />
    </li>
  );

}

export default MyBookingsWidget;
